import { Button } from "../beui/Button";
export const supportCategories = [
  ["bug", "Something's broken"], ["payment", "Payments / wallet"], ["account", "My account"],
  ["dispute", "A dispute"], ["abuse", "Report abuse"], ["other", "Something else"],
];
export const categoryLabel = (value: string) => supportCategories.find(([key]) => key === value)?.[1] || value;
export const statusLabel = (value: string) => value === "in_progress" ? "In progress" : value === "resolved" ? "Resolved" : "Open";
export function SupportReadError({ denied, retry }: { denied: boolean; retry: () => void }) {
  return <div className="support-error" role="alert"><p>{denied ? "This request isn't available. Check the profile selector, then retry. You may need to sign in again." : "Couldn't load support. Your draft is kept."}</p><Button variant="outline" onClick={retry}>Retry</Button></div>;
}
